import Vue from 'vue';
import ErrorsHandler from 'Services/ErrorsHandler';
import Feature from 'Services/Feature';
import Env from 'Services/Env';
import Store from 'Services/Store';
import { ElementUI, frlocale, enlocale } from '../vue/vue_common';
import filters from 'filters/vue_filters.js';
/**
 * Application Kernel
 */
export default class Kernel {
    /**
     * @param {Object} config
     */
    constructor(config) {
        this.config = config;
    }

    /**
     * Setup and boot application
     *
     * @var {Object} bootData Backend injected data
     */
    boot(bootData) {
        this.bootData = bootData;
        this.bootCoreServices();
        this.setupVue();

        window.sellsyapp = new Vue({
            el: '#sellsy_app',
            store: Store.getStates(),
            router: this.config.router,
            components: this.config.components,
        });

        Vue.prototype.$filters = filters;

        // Legacy boot
        if (this.config.bootLegacy) {
            this.config.bootLegacy.call();
        }
    }

    /**
     * Initialize and boot core services
     */
    bootCoreServices() {
        Env.set(this.bootData.config);
        Feature.set(this.bootData.features_flag);

        //add errorsHandler in system data
        this.bootData.system.errorsHandler = new ErrorsHandler();

        Store.set(
            this.bootData.intl,
            this.bootData.user,
            this.bootData.corporation,
            this.bootData.system,
            this.bootData.subscription_features,
            this.bootData.sellsy_subscription_dictionnary,
        );

        this.bootData.system.errorsHandler.boot();
        SellsyJS.WebServiceCaller.init();

        let TargetsDiscoveryFactory = require('sse/TargetsDiscoveryFactory').default;
        TargetsDiscoveryFactory.create();
    }

    /**
     * Setup of our Vue instances.
     * All properties added to Vue prototype will be available in Vue components.
     */
    setupVue() {
        window.Vue = Vue;
        Vue.config.lang = window.App.lang;
        window.App.lang == 'fr'
            ? Vue.use(ElementUI, { locale: frlocale })
            : Vue.use(ElementUI, { locale: enlocale });
    }
}
